import { Loader2Icon } from "lucide-react"
import styled from 'styled-components';

const StyledLoader = styled.div<{ $relative: boolean, $inline: boolean}>`
  position: ${props => (props.$inline) ? 'relative' : 'absolute'};
  width: ${props => (props.$relative) ? '100%' : '100vw'};
  height: ${props => (props.$relative) ? '100%' : '100vh'};
  ${props => (props.$inline) ? `width: auto; height: auto` : ''};
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
   animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

function Loader({relative = false, inline = false, size=22}) {

  return <StyledLoader $relative={relative} $inline={inline}><Loader2Icon width={size} hiehgt={size}/></StyledLoader>;
}

export default Loader;
